import {OutlookIndicator} from './outlook-indicator';
import {Indicator} from './indicator';
import {GovernmentId} from '../services/api/fit-api/models/government-id';
import {GovernmentSpecificity} from '../services/api/fit-api/models/government-specificity';

// note: named IndicatorGrouping instead of IndicatorGroup because IndicatorGroup is a model we get off the FIT API
export class IndicatorGrouping {
	//instantiationLevel: InstantiationLevel;
	//report: IndicatorReportType;
	//filingBasis: 'Cash' | 'GAAP' | 'None';

	constructor(
		public group: 'All Governmental Funds' | 'General Fund' | 'Enterprise Funds' | 'Other Indicators' | string,
		public governmentId: GovernmentId,
		public indicators: Array<Indicator>,
		// @deprecated
		public outlookIndicator?: OutlookIndicator)
	{}

	get indicatorOutlooks(): Array<OutlookIndicator> | undefined {
		if (this.governmentId.specificity === GovernmentSpecificity.GovernmentType) {
			return IndicatorGrouping.aggregateGovernmentOutlooks(this.indicators);
		}
		return this.indicators?.map(indicator => indicator?.outlookIndicatorForDisplayYear);
	}

	// Take an array of indicators (with a mix of governments) and generate an outlook for each government
	static aggregateGovernmentOutlooks = (indicators: Array<Indicator>) => {
		return indicators?.reduce((govts, indicator) => {
			let govt = govts.find(g => g.mcag === indicator.mcag);
			if (!govt) {
				govt = { mcag: indicator.mcag, indicatorOutlooks: [] };
				govts.push(govt);
			}
			govt.indicatorOutlooks.push(indicator.outlookIndicatorForDisplayYear);
			return govts;
		}, [] as Array<{ mcag: string, indicatorOutlooks: Array<OutlookIndicator> }>)
			.map(g => OutlookIndicator.aggregate(g.indicatorOutlooks));
	}
}


